import React, { Component } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  IconButton,
  withStyles,
  Tabs,
  Tab
} from '@material-ui/core';
import { convertTimeToMinute, minutesToTime } from '@dataGrid/gridUtilities';
import CloseIcon from "@material-ui/icons/Close";
import Tooltip from "../../../common/StyledToolTip";
import DynamicRoutingAnimation from "../../DialogAnimations/DynamicRoutingAnimation";
import appConstants from "../../../../appConstants";
import * as MergingRoutesAnimation from "../../DialogAnimations/MergingRoutesAnimation.json";
import * as ReadingDataAnimation from "../../DialogAnimations/ReadingDataAnimation.json";
import * as BuildingRoutesAnimation from "../../DialogAnimations/BuildingRoutesAnimation.json";
import * as SuccessAnimation from "../../DialogAnimations/SuccessAnimation.json";
import Slide from "@material-ui/core/Slide";
import { compose } from "recompose";
import { withFeatureFlags } from "../../../../userProfile/featureFlagsContext";
import RouteTimer from "./components/RouteTimer";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import AdvancedSettingsTab from './components/AdvancedSettingsTab';
import OptimizationConstraintsTab from './components/OptimizationConstraintsTab';
import { withAppConfig } from '../../../../appConfigContext';
import SelectedShipmentDetails from './components/SelectedShipmentDetails';
import RoutesSummary from './components/RoutesSummary';
import {
  getDynamicRoutingData,
  getGroupedDriverPreferencesListBasedOnPlanDate,
  getInitialIsReturnToTerminal,
  getInitialTrailerTypeCountList
} from './utils';
import { inject, observer } from 'mobx-react';
import { autorun } from 'mobx';
import DynamicRoutingValidation from './DynamicRoutingValidation';
import { RMAXLogger } from '../../../../services/LoggerService/RMAXLogger';
import Events from '../../../../utilities/EventEmitter';
import { APP_EVENT_NAMES } from '../../../../signalR/constants';
import { DynamicRoutingValidationProvider } from './DynamicRoutingValidation/context/DynamicRoutingValidationContext';
import DriverPreferencesTab from './components/DriverPreferencesTab';
import { getDataWithQueryString } from '../../../../api/componentAPIs';
import { inputFields } from './constants';
import Loader from '../../../modules/CustomerManagement/MarkLocation/common/components/Loader';

const styles = (theme) => ({
  dialogContainer: {
    padding: 16,
    userSelect: "none",
    backgroundColor: theme.ModalBGColor,
    maxWidth: "80vw",
    minWidth: 700
  },
  dialogTitle: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.HeaderSelectedText,
    padding: "0 0 8px"
  },
  dialogContent: {
    overflowY: "auto",
    padding: "0 0 24px",
    position: "relative"
  },
  gridContainer: {
    padding: 24,
  },
  gridItemHead: {
    fontWeight: 600,
  },
  gridItem: {
    fontSize: theme.textFontSize,
    color: theme.gridTextColor,
    "&>div": {
      marginTop: 0,
    },
  },
  fieldSet: {
    border: `1px solid ${theme.AppBGColor}`,
    padding: "9px 12px",
    borderRadius: 3,
    marginBottom: 8
  },
  closeIconStyle: {
    padding: "0px",
    float: "right",
    color: theme.HeaderDefaultTextColor,
    "&:hover": {
      backgroundColor: theme.ModalBGColor,
      color: theme.HeaderSelectedText,
    },
  },
  actionContainer: {
    display: "flex",
    width: "60%",
    justifyContent: "space-between",
    margin: 0
  },
  dialogActionStyle: {
    padding: 0,
    margin: 0
  },

  dialogButtonStyle: {
    fontSize: 14,
    textTransform: "none",
    borderRadius: "2px",
    float: "right",
    width: "48%",
    "&$disabledButton,&$disabledButton:hover": {
      cursor: "not-allowed",
      pointerEvents: "all",
      backgroundColor: theme.customInputBGColor,
      color: theme.white,
    },
  },
  warningMessage: {
    fontSize: theme.textFontSize,
    fontWeight: 500,
    color: theme.ErrorMessageColor,
    padding: "8px 0 0 0",
  },
  closeIcon: {
    fontSize: 24,
  },
  disabledButton: {
    cursor: "not-allowed",
    pointerEvents: "all",
    backgroundColor: theme.iconColor,
    color: theme.white,
  },
  buttonLabel: {
    width: "100%",
  },
  inputError: {
    "&>div": {
      borderColor: theme.ErrorMessageColor,
    },
  },
  progressDialogTitle: {
    fontSize: "25px",
    fontWeight: 600,
    textAlign: "center",
    lineHeight: "34px",
    color: theme.HeaderSelectedText,
  },
  drProgressContent: {
    fontSize: "16px",
    lineHeight: "17px",
    overflow: "hidden",
    color: theme.TextColor,
    position: "relative"
  },
  percentageComplete: {
    padding: "24 0 10 0",
    textAlign: "center",
    color: theme.TextColor,
    lineHeight: "22px",
    fontSize: 17,
    fontWeight: 500
  },
  didYouKnowTitle: {
    textAlign: "center",
    fontWeight: 600,
    lineHeight: "22px",
    color: theme.HeaderSelectedText,
    paddingTop: "24px",
  },
  factsWrapper: {
    color: theme.gridTextColor,
    textAlign: "center",
    fontStyle: "italic",
    lineHeight: "34px",
    padding: "12px 0px",
  },
  returnToTerminalWrapper: { display: "flex", alignItems: "center" },
  checkbox: {
    padding: 0,
    marginRight: 8,
    color : theme.iconColor
  },
  returnToTerminalLabel : {
    marginRight : 8
  },
  tabsRoot: {
    minHeight: 0,
    border: `1px solid ${theme.AppBGColor}`,
    borderBottom: 'none',
    borderRadius: "3px 3px 0 0"
  },
  tabRoot: {
    color: theme.TextColor,
    textTransform: 'none',
    fontSize: theme.textFontSize,
    fontWeight: 500,
    '&$tabSelected': {
      color: theme.HeaderSelectedText
    },
    '&:hover': {
      color: theme.HeaderSelectedText,
      opacity: 1
    },
    minWidth: 140,
    minHeight: 0
  },
  tabsIndicator: {
    display: 'none'
  },
  labelContainer: {
    padding: '6px 8px'
  },
  tabSelected: {},
  tabsContent: {
    border: `1px solid ${theme.AppBGColor}`,
    padding: "9px 12px",
    borderRadius: "0 0 3px 3px",
  },
  dialogContentWrapper: {
    position: 'relative',
  },
});

const DYNAMIC_ROUTING_TABS = {
  optimizationConstraintsTab: 'optimizationConstraintsTab',
  advancedSettingsTab: 'advancedSettingsTab',
  driverPreferencesTab: 'driverPreferencesTab'
};

@inject("IBPlanningStore", "CommonStore")
@observer
class DynamicRoutingDialog extends Component {
  constructor(props) {
    super(props);
    this.savedFormData = JSON.parse(
      sessionStorage.getItem(
        `dynamicRoutingFormData_${this.props.userData.userProfile.terminal.id}`
      )
    );
    this.data = getDynamicRoutingData({
      routesList: this.props.IBPlanningStore.routesList,
      selectedRouteNameList: this.props.IBPlanningStore.selectedRouteNameList,
      trailersData: this.props.CommonStore.availableTrailers,
      parametersData: this.props.CommonStore.parametersData,
      wavesData: this.props.CommonStore.wavesData
    });
    this.state = {
      constraintError: '',
      errorField: '',
      enableConfirm: true,
      openDialog: this.props.inProgress ? this.props.inProgress : this.props.show,
      isValidationDialogOpen: false,
      progressPercentage: this.props.dynamicRoutingProgressValue,
      isReturnToTerminal: getInitialIsReturnToTerminal({
        isReturnToTerminalCheckedByDefault: this.props.featureFlags.isFeatureEnabled(
          appConstants.features.EnableReturnToTerminalCheckedByDefault
        ),
        disableReturnToTerminalOption: this.props.featureFlags.isFeatureEnabled(
          appConstants.features.DisableReturnToTerminalOption
        ),
        savedFormData: this.savedFormData
      }),
      activeTab: DYNAMIC_ROUTING_TABS.optimizationConstraintsTab,
      mergedExtraRouteName: this.savedFormData?.mergedExtraRouteName ?? this.data.optimizationConstraints.mergedExtraRouteName,
      isMergeExtraRoutes: this.savedFormData?.isMergeExtraRoutes ?? this.data.optimizationConstraints.isMergeExtraRoutes,
      extraRouteError: null,
      maxStopsPerRouteCount:
        this.savedFormData?.maxStopsPerRouteCount ??
        this.data.optimizationConstraints.maxStopsPerRouteCount,
      lastWaveCutOff:
        this.savedFormData?.lastWaveCutOff ??
        this.data.optimizationConstraints.lastWaveCutOff,
      maxNumberOfTripsCount: null,
      trailerTypeCountList: getInitialTrailerTypeCountList(this.savedFormData?.trailers, this.data),
      dynamicRoutingInputData: {},
      groupedDriverPreferencesList: [],
    };
    const factsArray = appConstants.DYNAMIC_ROUTING_PROGRESS_MESSAGES;
    this.didYouKnowText = factsArray[Math.floor(Math.random() * factsArray.length)];
  }

  componentDidMount = () => {
    this.fetchGroupedDriverPreferences();
    if (this.props.isDynamicRoutingTriggeredByShipmentSelection) {
      // Recalculate data reactively when store data changes (for shipment selection flow)
      this.dataUpdateDisposer = autorun(() => {
        this.data = getDynamicRoutingData({
          routesList: this.props.IBPlanningStore.routesList,
          selectedRouteNameList: this.props.IBPlanningStore.selectedRouteNameList,
          trailersData: this.props.CommonStore.availableTrailers,
          parametersData: this.props.CommonStore.parametersData,
          wavesData: this.props.CommonStore.wavesData
        });
        this.setState({
          trailerTypeCountList: getInitialTrailerTypeCountList(this.savedFormData?.trailers, this.data),
        });
      });
    }
  }

  componentWillUnmount() {
    if (this.dataUpdateDisposer) {
      this.dataUpdateDisposer();
    }
  }

  componentDidUpdate(prevProps) {
    // Log when dialog opens due to city routes (shipment selection)
    if (
      !prevProps.show && 
      this.props.show && 
      this.props.isDynamicRoutingTriggeredByShipmentSelection
    ) {
      RMAXLogger.addAction('DynamicRouting: Dialog opened by city routes (shipment selection)', {
        triggerType: 'city_routes_shipment_selection',
        action: 'dialog_opened',
        totalRoutes: this.data?.totalRoutes || 0,
        selectedRouteCount: this.data?.selectedRoutes?.length || 0
      });
    }

    //update dynamic routing progress percentage iff it is greater than the previous value
    if (
      this.props.dynamicRoutingProgressValue >
      prevProps.dynamicRoutingProgressValue
    ) {
      this.setState({
        progressPercentage: this.props.dynamicRoutingProgressValue,
      });
    }

    //After dynamic routing completion, keep dialog open for sometime to show success animation
    if (this.props.isCompleted) {
      setTimeout(() => {
        this.props.onClose();
      }, 2000);
    }

    // When data finishes loading and city routes are not found, close silently without showing a dialog
    if (
      prevProps.isDataLoading &&
      !this.props.isDataLoading &&
      !this.props.isCityRoutesPresentInRoutesList()
    ) {
      RMAXLogger.error('CityRoutesNotFound: Selected city routes not found in grid when Dynamic Routing is triggered by Shipment Selection', {
        expectedRouteCount: this.props.cityRoutes?.length || 0,
        availableRouteCount: this.props.IBPlanningStore.routesList?.length || 0
      });
      this.handleCityRoutesNotFoundClose();
    }
  }

  fetchGroupedDriverPreferences = () => {
    const  terminalId  = this.props.userData.userProfile.terminal.id;
    const { enableGroupedDriverPreferences } = this.props.configJSON;

    if (!terminalId || !enableGroupedDriverPreferences) {
      return;
    }
    
    getDataWithQueryString('GetGroupedDriverPreferences', `terminalId=${terminalId}`).then(
      (response) => {
        if (response.status === 200) {
          this.setGroupedDriverPreferences(response.data);
        } 
      }
    );
  };

  setGroupedDriverPreferences = (data) => {
    const driverPreferencesList = getGroupedDriverPreferencesListBasedOnPlanDate(
      data,
      this.props.userData.userProfile.planDate
    )
    this.setState({
      groupedDriverPreferencesList: driverPreferencesList
    });
  }

  // Add validation helper methods
  validateTrailerCounts = (trailerTypeCountList) => {
    const hasNullTrailerCount = trailerTypeCountList.some(trailer => trailer.trailerCount === null);
    
    if (!hasNullTrailerCount) {
      const totalTrailerCount = trailerTypeCountList.reduce((acc, trailer) => acc + (trailer.trailerCount ?? 0), 0);
      if (totalTrailerCount < 1) {
        return {
          error: "Please enter a non-zero value for atleast one trailer",
          field: inputFields.trailerTypeCountList
        };
      }
    }
    return { error: null, field: null };
  };

  validateMaxStopsPerRoute = (maxStopsPerRouteCount) => {
    if (!maxStopsPerRouteCount) {
      return {
        error: "Please enter a valid input for max stops - More than zero",
        field: inputFields.maxStopsPerRoute
      };
    }
    return { error: null, field: null };
  };

  isMaxTripsConstraintEnabled = () =>
    this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnableMaxTripsConstraintInDRPopup
    );

  /** Optional field: null or numeric count from NumericEditor; API gets null unless value is > 0. */
  getMaxNumberOfTripsForPayload = (maxNumberOfTripsCount) =>
    maxNumberOfTripsCount > 0 ? maxNumberOfTripsCount : null;

  // Helper method for clearing errors
  clearFieldError = (fieldName) => {
    this.setState(prevState => {
      if(prevState.errorField === fieldName){
        return {
          errorField: '',
          constraintError: '',
          enableConfirm: true
        }
      }
    });
  };

  handleSubmit = () => {
    const {
      isMergeExtraRoutes,
      mergedExtraRouteName,
      lastWaveCutOff,
      maxStopsPerRouteCount,
      trailerTypeCountList,
      isReturnToTerminal
    } = this.state;
    const trailers = trailerTypeCountList;

    const trailerValidation = this.validateTrailerCounts(trailerTypeCountList);
    if (trailerValidation.error) {
      this.setState({
        constraintError: trailerValidation.error,
        errorField: trailerValidation.field,
        enableConfirm: false,
      });
      return;
    }
    
    if (this.isMaxStopsPerRouteInputEnabled()) {
      const maxStopsValidation = this.validateMaxStopsPerRoute(maxStopsPerRouteCount);
      if (maxStopsValidation.error) {
        this.setState({
          constraintError: maxStopsValidation.error,
          errorField: maxStopsValidation.field,
          enableConfirm: false,
        });
        return;
      }
    }

    const dynamicRoutingInputData = {
      maxStopsPerRoute: this.isMaxStopsPerRouteInputEnabled() ? maxStopsPerRouteCount : null,
      lastWaveCutOff: convertTimeToMinute(lastWaveCutOff),
      numberOfExpectedRoutes: 0, // needs to be sent since api structure expects this field but doesn't read this value
      trailers,
      routeNames: this.data.selectedRoutes,
      isReturnToTerminal,
      ...(this.props.configJSON.showAdvancedSettingsTab && {
        isMergeExtraRoutes,
        mergedExtraRouteName
      })
    };

    if(this.isInputValidationForDynamicRoutingEnabled()){
      this.setState({
        isValidationDialogOpen: true,
        dynamicRoutingInputData
      });
    }else{
      this.runOptimization({ excludedPros: [], dynamicRoutingInputData });
    }
  };

  runOptimization = ({
    excludedPros = [],
    dynamicRoutingInputData = null
  } = {}) => {
    const shouldSaveFormDataToSession = !this.data.isOnlyFMERoute && !this.data.isOnlyLinkexRoute;
    if (shouldSaveFormDataToSession) {
      this.saveDataToSessionStorage();
    }
  
    const data = dynamicRoutingInputData ?? { ...this.state.dynamicRoutingInputData };
    const payload = { ...data };

    if (this.isMaxTripsConstraintEnabled()) {
      payload.maxNumberOfTrips = this.getMaxNumberOfTripsForPayload(
        this.state.maxNumberOfTripsCount
      );
    }

    const driverPreferences = this.getDriverPreferencesForOptimization();

    if(this.props.configJSON.enableGroupedDriverPreferences){
      payload.driverPreferences = driverPreferences;
    }

    if (excludedPros?.length) {
      payload.excludedProNumbers = excludedPros;
    }

    // Log when user proceeds with optimization (especially if triggered by city routes)
    if (this.props.isDynamicRoutingTriggeredByShipmentSelection) {
      RMAXLogger.addAction('DynamicRouting: User proceeded with optimization (city routes)', {
        triggerType: 'city_routes_shipment_selection',
        action: 'optimization_started',
        selectedRouteCount: payload.routeNames?.length || 0
      });
    }
  
    this.props.triggerDynamicRouting?.(payload);
    this.closeValidationPopup(false);
  };

  saveDataToSessionStorage = () => {
    const {
      trailers,
      lastWaveCutOff,
      maxStopsPerRoute,
      isReturnToTerminal,
      isMergeExtraRoutes,
      mergedExtraRouteName
    } = this.state.dynamicRoutingInputData;
    
    sessionStorage.setItem(
      `dynamicRoutingFormData_${this.props.userData.userProfile.terminal.id}`,
      JSON.stringify({
        trailers,
        lastWaveCutOff: minutesToTime({ value: lastWaveCutOff }),
        ...(this.isMaxStopsPerRouteInputEnabled() && { maxStopsPerRouteCount: maxStopsPerRoute }),
        isReturnToTerminal,
        ...(this.props.configJSON.showAdvancedSettingsTab && {
          isMergeExtraRoutes,
          mergedExtraRouteName
        })
      })
    );
  };

  getDriverPreferencesForOptimization = () => {
    const { groupedDriverPreferencesList } = this.state;
    return groupedDriverPreferencesList.filter(item => Boolean(item.startTime));
  };

  isInputValidationForDynamicRoutingEnabled = () => {
    return this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnableInputValidationForDynamicRouting
    );
  };

  isMaxStopsPerRouteInputEnabled = () =>
    this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnableMaxStopsPerRouteInput
    );
  
  updateAnimation = (progress) => {
    if (this.props.isCompleted) {
      return {
        animationText: "Success",
        animationData: SuccessAnimation.default,
      };
    } else {
      if (progress === 0) {
        return {
          animationText: "Job Queued",
          animationData: ReadingDataAnimation.default,
        };
      } else if (progress <= 30) {
        return {
          animationText: "Reading Data",
          animationData: ReadingDataAnimation.default,
        };
      } else if (progress > 30 && progress <= 60) {
        return {
          animationText: "Building Routes",
          animationData: BuildingRoutesAnimation.default,
        };
      } else {
        return {
          animationText: "Merging Routes",
          animationData: MergingRoutesAnimation.default,
        };
      }
    }
  };

  onMaxStopsPerRouteCountChange = (maxStopsPerRouteCount) => {
    this.setState({ maxStopsPerRouteCount });
    if (this.state.errorField === inputFields.maxStopsPerRoute && !this.validateMaxStopsPerRoute(maxStopsPerRouteCount).error) {
      this.clearFieldError(inputFields.maxStopsPerRoute);
    }
  };

  onMaxNumberOfTripsCountChange = (maxNumberOfTripsCount) => {
    this.setState({ maxNumberOfTripsCount });
  };

  onDialogClosed = () => {
    if (!this.props.inProgress) {
      // Log when user closes dialog (especially if triggered by city routes)
      if (this.props.isDynamicRoutingTriggeredByShipmentSelection) {
        RMAXLogger.addAction('DynamicRouting: User closed dialog (city routes)', {
          triggerType: 'city_routes_shipment_selection',
          action: 'dialog_closed',
          selectedRouteCount: this.data?.selectedRoutes?.length || 0
        });
      }
      this.props.onClose();
    }
  };

  handleCityRoutesNotFoundClose = () => {
    if (this.props.isDynamicRoutingTriggeredByShipmentSelection) {
      RMAXLogger.addAction('DynamicRouting: User closed dialog - city routes not found', {
        triggerType: 'city_routes_shipment_selection',
        action: 'closed_routes_not_found',
        expectedRouteCount: this.props.cityRoutes?.length || 0
      });
      this.props.IBPlanningStore.updateIsFirstOptimizationRun(false);
      const scenarioId = this.props.userData?.userProfile?.scenarioID;
      if (scenarioId) {
        Events.emit(APP_EVENT_NAMES.IBPLANNING.ClearETLCityRoutes, scenarioId);
      }
    }
    this.props.IBPlanningStore.updateSelectedRoutes([]);
    this.props.onClose();
  }

  closeValidationPopup = (shouldRefreshStore = true) => {
    this.setState({ isValidationDialogOpen: false });
    if (shouldRefreshStore) {
      this.handleRefreshIBStore();
    }
  };

  cancelOptimization = () => {
    RMAXLogger.info("Cancelled dynamic routing validation");
    
    // Log when user cancels optimization (especially if triggered by city routes)
    if (this.props.isDynamicRoutingTriggeredByShipmentSelection) {
      RMAXLogger.addAction('DynamicRouting: User cancelled optimization (city routes)', {
        triggerType: 'city_routes_shipment_selection',
        action: 'cancelled',
        selectedRouteCount: this.data?.selectedRoutes?.length || 0
      });
    }
    
    this.handleRefreshIBStore()
    this.onDialogClosed();
  };

  handleRefreshIBStore = () => {
    Events.emit('RefreshIBStore', {
      showNotification: false,
      selectedRoutesList: this.state.dynamicRoutingInputData.routeNames
    });
  }

  onTrailerCountChange = (trailerId) => (e) => {
    const value = e.target.value ? parseInt(e.target.value) : null;
    const { trailerTypeCountList } = this.state;
    const trailerIndex = trailerTypeCountList.findIndex(trailer => trailer.trailerId === trailerId);

    if (trailerIndex !== -1) {
      trailerTypeCountList[trailerIndex].trailerCount = value;
    } else {
      trailerTypeCountList.push({ trailerId, trailerCount: value });
    }
    
    this.setState({ trailerTypeCountList });
    
    if (this.state.errorField === inputFields.trailerTypeCountList && !this.validateTrailerCounts(trailerTypeCountList).error) {
      this.clearFieldError(inputFields.trailerTypeCountList);
    }
  }

  getDialogTitle = () => {
    const { inProgress } = this;
    if (!inProgress) {
      return `Dynamic Routing: ${this.data.totalRoutes} Routes will be affected`;
    }
    return this.state.progressPercentage < 1
      ? 'Optimization about to start...'
      : 'Dynamic Routing in progress';
  };

  getSubmitButtonTooltip = () => {
    if (this.data.totalLockedRoutes) {
      return 'Cannot optimize as locked routes are selected';
    }
    return !this.state.enableConfirm ? 'Cannot optimize due to incorrect constraints' : '';
  };

  getSubmitButtonLabel = () => {
    if(this.isInputValidationForDynamicRoutingEnabled()) {
      return 'Validate & Optimize';
    }else{
      return 'Confirm';
    }
  }

  handleTabChange = (event, value) => {
    this.setState({ activeTab: value });
  };

  onFormDataChange = (name, value) => {
    this.setState({ [name]: value });
    if ([inputFields.isMergeExtraRoutes, inputFields.mergedExtraRouteName].includes(name)) {
      const error = this.getExtraRouteErrorMessage(name, value);
      this.setState({ extraRouteError: error });
    }
  };

  getExtraRouteErrorMessage = (name, value) => {
    if (name === inputFields.isMergeExtraRoutes && !value) {
      this.setState({
        mergedExtraRouteName: this.data.optimizationConstraints.mergedExtraRouteName
      });
    } else if (name === inputFields.mergedExtraRouteName) {
      if (!value) {
        return 'Please update with a valid routeName';
      }
      if (value !== this.data.optimizationConstraints.mergedExtraRouteName &&
        this.props.IBPlanningStore.routesList.some((route) => route.routeName === value)       
      ) {
        return `A route with name ${value} already exists`;
      }
    }
    return null;
  };

  render() {
    const { classes, inProgress, dynamicRoutingProgressValue, themeName, isDataLoading, isDynamicRoutingTriggeredByShipmentSelection } = this.props;
    const {
      activeTab,
      mergedExtraRouteName,
      isMergeExtraRoutes,
      maxStopsPerRouteCount,
      maxNumberOfTripsCount,
      lastWaveCutOff,
      trailerTypeCountList,
      extraRouteError
    } = this.state;
    const { animationText, animationData } = this.updateAnimation(this.state.progressPercentage);
    const hideReturnToTerminalOption = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.DisableReturnToTerminalOption
    );
    const showMaxNumberOfTrips = this.isMaxTripsConstraintEnabled();

    const tabsList = [
      {
        label: "Optimization Constraints",
        value: DYNAMIC_ROUTING_TABS.optimizationConstraintsTab,
        show: true
      },
      {
        label: "Advanced Settings",
        value: DYNAMIC_ROUTING_TABS.advancedSettingsTab,
        show: this.props.configJSON.showAdvancedSettingsTab
      },
      {
        label: "Driver Preferences",
        value: DYNAMIC_ROUTING_TABS.driverPreferencesTab,
        show: this.props.configJSON.enableGroupedDriverPreferences
      }
    ];

    const isSubmitButtonDisabled = Boolean(
      !this.state.enableConfirm || this.data.error || extraRouteError || isDataLoading
    );

    const isCityRoutesPresentInRoutesList = this.props.isCityRoutesPresentInRoutesList();

    return this.state.isValidationDialogOpen ? (
      <DynamicRoutingValidationProvider>
        <DynamicRoutingValidation
          show={this.state.isValidationDialogOpen}
          inputData={this.state.dynamicRoutingInputData}
          enableMaxStopsPerRouteInput={this.isMaxStopsPerRouteInputEnabled()}
          onClose={this.closeValidationPopup}
          cancelOptimization={this.cancelOptimization}
          runOptimization={this.runOptimization}
          glEventHub={this.props.glEventHub}
          userData={this.props.userData}
          themeName={themeName}
          handleDynamicRoutingError={this.props.handleDynamicRoutingError}
          isDynamicRoutingTriggeredByShipmentSelection={this.props.isDynamicRoutingTriggeredByShipmentSelection}
        />
      </DynamicRoutingValidationProvider>
    ) : (
      <Dialog
        open={this.state.openDialog}
        onClose={this.onDialogClosed}
        disableBackdropClick
        disableEscapeKeyDown
        classes={{ paper: classes.dialogContainer }}
        className={themeName}
        aria-labelledby="dynamic-routing">
        <DialogTitle
          classes={{
            root: `${
              inProgress ? classes.progressDialogTitle : classes.dialogTitle
              }`,
          }}
          disableTypography
          >
          {this.getDialogTitle()}
          {!inProgress && !isDynamicRoutingTriggeredByShipmentSelection && (
            <IconButton
              aria-label="Close"
              classes={{ root: classes.closeIconStyle }}
              onClick={this.onDialogClosed}
              >
              <CloseIcon classes={{ root: classes.closeIcon }} />
            </IconButton>
          )}
        </DialogTitle>
        <DialogContent
          className={`${
            inProgress ? classes.drProgressContent : classes.dialogContent
          } customScroll`}
        >
        {isDataLoading ? (
          <Loader
            message="Loading data..."
            delayed={false}
          />
        ) : null}
        {!inProgress ? (
            <div>
              <div className={classes.fieldSet}>
                <SelectedShipmentDetails data={this.data} />
              </div>
              <div className={classes.fieldSet}>
                <RoutesSummary data={this.data} />
              </div>
              <Tabs
                value={activeTab}
                onChange={this.handleTabChange}
                classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
                indicatorColor="primary">
                {tabsList.map(
                  (tab) =>
                    tab.show && (
                      <Tab
                        key={tab.value}
                        classes={{
                          root: classes.tabRoot,
                          selected: classes.tabSelected,
                          labelContainer: classes.labelContainer
                        }}
                        label={tab.label}
                        value={tab.value}
                      />
                    )
                )}
              </Tabs>

              <div className={`${classes.tabsContent}`}>
                {({
                  [DYNAMIC_ROUTING_TABS.optimizationConstraintsTab]: (
                    <OptimizationConstraintsTab
                      data={this.data}
                      hideReturnToTerminalOption={hideReturnToTerminalOption}
                      enableMaxStopsPerRouteInput={this.isMaxStopsPerRouteInputEnabled()}
                      isReturnToTerminal={this.state.isReturnToTerminal}
                      maxStopsPerRouteCount={maxStopsPerRouteCount}
                      maxNumberOfTripsCount={maxNumberOfTripsCount}
                      showMaxNumberOfTrips={showMaxNumberOfTrips}
                      lastWaveCutOff={lastWaveCutOff}
                      errorField={this.state.errorField}
                      constraintError={this.state.constraintError}
                      onFormDataChange={this.onFormDataChange}
                      onMaxStopsPerRouteCountChange={this.onMaxStopsPerRouteCountChange}
                      onMaxNumberOfTripsCountChange={this.onMaxNumberOfTripsCountChange}
                      onTrailerCountChange={this.onTrailerCountChange}
                      trailerTypeCountList={trailerTypeCountList}
                    />
                  ),
                  [DYNAMIC_ROUTING_TABS.advancedSettingsTab]: (
                    <AdvancedSettingsTab
                      classes={classes}
                      isMergeExtraRoutes={isMergeExtraRoutes}
                      mergedExtraRouteName={mergedExtraRouteName}
                      onFormDataChange={this.onFormDataChange}
                      extraRouteError={extraRouteError}
                    />
                  ),
                  [DYNAMIC_ROUTING_TABS.driverPreferencesTab]: (
                    <DriverPreferencesTab
                      data={this.state.groupedDriverPreferencesList}
                      onFormDataChange={this.onFormDataChange} 
                    />
                  )
                }[activeTab] || null)}
              </div>
              <div className={classes.warningMessage}>Note: This action cannot be reversed.</div>
            </div>
          ) : (
            <div>
              <DynamicRoutingAnimation dimension={280} animationJSON={animationData} />
              {this.state.progressPercentage === 0 ? (
                <div className={classes.percentageComplete}>{animationText}</div>
              ) : (
                <div className={classes.percentageComplete}>
                {animationText}:{" "}
                {dynamicRoutingProgressValue >= 100
                  ? 100
                  : this.state.progressPercentage}
            % completed
              </div>
              )}
              <RouteTimer
                progressPercentage={this.props.dynamicRoutingProgressValue}
                updateOptimizationRunTime={this.props.updateOptimizationRunTime}
              />
              <div className={classes.didYouKnowTitle}>Did You Know?</div>
              <div className={classes.factsWrapper}>
                <Slide direction="right" in={true}>
                  <div>{this.didYouKnowText}</div>
                </Slide>
              </div>
            </div>
          )}
        </DialogContent>
        {!inProgress && isCityRoutesPresentInRoutesList && (
          <DialogActions classes={{ root: classes.dialogActionStyle }}>
            <div className={classes.actionContainer}>
              {!isDynamicRoutingTriggeredByShipmentSelection && (
                <Button
                  variant="outlined"
                  onClick={this.onDialogClosed}
                  color="primary"
                  size="medium"
                  className={classes.dialogButtonStyle}
                  >
                  Cancel
                </Button>
              )}
              <Button
                variant="contained"
                onClick={this.handleSubmit}
                color="primary"
                size="medium"
                classes={{
                  root: classes.dialogButtonStyle,
                  disabled: classes.disabledButton
                }}
                disabled={isSubmitButtonDisabled}>
                <Tooltip title={this.getSubmitButtonTooltip()}>
                  <span className={classes.buttonLabel}> {this.getSubmitButtonLabel()} </span>
                </Tooltip>
              </Button>
            </div>
          </DialogActions>
        )}
      </Dialog>
    );
  }
}

export default compose(
  withFeatureFlags,
  withUserProfile,
  withStyles(styles),
  withAppConfig
)(DynamicRoutingDialog);
